import { getCoursePackageData } from "../../../utils/getCoursePackageData";
import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook";
import { transformLevelContent } from "../../../utils/transformLevelContent";
import { useTranslation } from "../../../utils/hooks/translateHook.js";
import { hasAccess } from "../../../utils/permissions";
import { useNavigate } from "react-router-dom";
import './Packages.css'


function Packages({courseSlug, user}) {
  const rawData = getCoursePackageData(courseSlug);
  const translatedData = useLevelContentData(rawData, courseSlug);
  const levelData = transformLevelContent(translatedData);
  const t = useTranslation();
  const navigate = useNavigate();
  
  // const debugUser = {...user,subscriptionLevel: 400 };
  const effectiveUser = user; // or debugUser
  const packages = levelData
    .filter(p => p.level !== 9999 && p.level !== 0)
    .map(pkg => ({...pkg, isAboveUser: pkg.level > effectiveUser?.subscriptionLevel}));

  const currentPackage = packages.find(
    pkg => pkg.level === user?.subscriptionLevel
  ); // only fir check - delete after 

  // const currentPackage = packages.find(pkg => pkg.level === user?.subscriptionLevel);

console.log("USER LEVEL:", user.subscriptionLevel);
console.log("ALL PACKAGES:", packages.map(p => p.level));
    
  console.log("Packages slug:", courseSlug);

  return (
    <section name="package-card-container" className="container-packages">
     <h1>
        {user && currentPackage ? (
          <>
            {t("package.currentPackage")}{" "}
            <span className="highlight-package"> {currentPackage.title} </span>
          </>
        ) : ( t("package.noPackage") )}
      </h1>
      <div className="container-grid">
        {packages.map((pkg, index) => (

          <div className={`container-grid-item ${pkg.title.toLowerCase()} ${pkg.isAboveUser ? "disabled" : ""}`}
            key={pkg.level}
          >
           <div className="card-header">
             {pkg.title} 
             {pkg.isAboveUser && (<span className="lock-icon-header">🔒</span>)}
           </div>
           {pkg.isAboveUser && (
            <div className="upgrade-overlay">
              <button className="upgrade-btn-card" 
                onClick={() => navigate("/upgrade")}
              > UPGRADE
              </button>
            </div>
           )}
            <div className="text-container">
              <div className="text-content">
                {pkg.packageDescription}
              </div>
              <div className="card-line"></div>
              <div className="text-bottom-content">
                <ul>
                  {pkg.packageFeatures?.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div> 
            </div>
            <div className="card-number">{index + 1}</div>
            <div className="card-bottom"></div>
          </div>
        ))}
      </div>
    </section>
  )
}


export default Packages;